module.exports = __webpack_public_path__ + "img/pod.50727f7c.svg";